import React, { useState } from 'react';
import { Card } from 'antd';

import EquipmentForm from '../EquipmentForm/EquipmentForm';
import Headline from '../../../UI/Headline/Headline';
import api from '../../../../api';

function CreateEquipment({ companyId }) {
    const addEquipmentHandler = async (equipment) => {
        const addedEq = { ...equipment, companyId: Number(companyId) };
        await api.addEquipment(addedEq);
        window.location.href = '/admin/equipments';
    };

    return (
        <Card bordered>
            <Headline title="Dodaj sprzęt" />
            <EquipmentForm
                successHandler={addEquipmentHandler}
                submitButtonText="Dodaj sprzęt"
            />
        </Card>
    );
}

export default CreateEquipment;
